import styled from "styled-components";
import { Title } from "../../../../../../ui/Title";

export const StyledTitle = styled(Title)`
  color: #fff;
  text-align: center;
  font-size: 1.3em;
  font-weight: 700;
  padding-bottom: 0.6em;
  letter-spacing: 0.04em;
`;
